import { useMemo, useState } from 'react';
import Button from '../../components/Button/Button';
import Checkbox from '../../components/Inputs/Checkbox/Checkbox';
import PDF from '../../components/Pdf';

const ROLE_LABEL = { seller: 'Продавец', buyer: 'Покупатель', agent: 'Агент' };

// Страница публичная, а pdf и sign приходят из адресной строки. Без проверки
// происхождения любой мог бы собрать ссылку на наш домен, которая показывает
// чужой договор и уводит «подписывать» на свой сайт. Ссылки на подписание
// выпускает бэкенд и кладёт их на APP_URL (сокращатель) — только его и пускаем.
export const parseOrigins = (...values) =>
  values
    .filter(Boolean)
    .flatMap((value) => String(value).split(','))
    .map((value) => {
      try {
        return new URL(String(value).trim()).origin;
      } catch {
        return null;
      }
    })
    .filter(Boolean);

const ALLOWED_ORIGINS = parseOrigins(process.env.REACT_APP_API_URL, process.env.REACT_APP_SIGN_ORIGINS);

// Отказ здесь чаще всего означает не атаку, а разъехавшуюся настройку:
// ссылки собирает бэкенд из APP_URL и APP_URL_LOCAL, а список — из
// REACT_APP_API_URL. Молча ронять ссылку нельзя, иначе получатель СМС видит
// «недействительна», и в логах ни следа.
export const safeUrl = (value, field, allowed = ALLOWED_ORIGINS) => {
  let url;
  try {
    url = new URL(String(value || ''));
  } catch {
    if (value) console.warn(`signTripartite: ${field} — не абсолютный url`, value);
    return '';
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') {
    console.warn(`signTripartite: ${field} — запрещённый протокол`, url.protocol);
    return '';
  }
  if (!allowed.includes(url.origin)) {
    console.warn(
      `signTripartite: ${field} — origin ${url.origin} не в списке разрешённых`,
      allowed,
      'проверьте REACT_APP_API_URL / REACT_APP_SIGN_ORIGINS против APP_URL и APP_URL_LOCAL на бэке'
    );
    return '';
  }
  return url.href;
};

const SignTripartite = () => {
  const state = useMemo(() => {
    try {
      const raw = new URLSearchParams(window.location.search).get('state');
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }, []);
  const [agree, setAgree] = useState(false);
  const pdf = safeUrl(state.pdf, 'pdf');
  const sign = safeUrl(state.sign, 'sign');
  const role = ROLE_LABEL[state.role] || '';

  if (!pdf || !sign) {
    const rejected = Boolean(state.pdf || state.sign);
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <h1>Ссылка недействительна</h1>
        <p>Попросите менеджера отправить СМС ещё раз.</p>
        {rejected ? (
          <p style={{ color: '#667' }}>Ссылка выдана другим адресом — назовите менеджеру код ORIGIN.</p>
        ) : null}
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '0 15px',
        width: '100%',
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <h1 style={{ margin: '20px 0' }}>
        Внимательно ознакомьтесь с договором и перейдите к подписанию
      </h1>
      {role ? (
        <p style={{ margin: '0 0 12px', color: '#667' }}>
          Вы подписываете как {role}
          {state.name ? `: ${state.name}` : ''}
        </p>
      ) : null}
      <a href={pdf} target="_blank" rel="noreferrer" style={{ marginBottom: 12 }}>
        Открыть PDF
      </a>
      <div style={{ position: 'relative', flex: 1, overflow: 'auto', minHeight: 320 }}>
        <PDF url={pdf} />
      </div>
      <div style={{ marginTop: 20 }}>
        <Checkbox
          id="agree"
          value={agree}
          onChange={(id, value) => setAgree(value)}
          label="Ознакомлен и согласен с договором"
        />
      </div>
      <div style={{ margin: '20px 0' }}>
        <Button
          fill
          full
          text="Перейти к подписанию"
          disabled={!agree}
          onClick={() => {
            window.location.href = sign;
          }}
        />
      </div>
    </div>
  );
};

export default SignTripartite;
